

export default function formatCNPJ(value) {

    if (value === undefined || value === null) {
        return value
    }

    if (typeof value === "number") {
        value = value.toString()
    }

    if (typeof value !== "string") {
        return value
    }

    value = value.replace(/\D/g, "")

    value = value.padStart(14, "0")

    return value.replace(
        /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/,
        "$1.$2.$3/$4-$5"
    )
}

